<div class="padding-20" id="actionMenu">
  <br />
  <div class="ui-g-12">
    <app-campaign-3-kontable *ngIf="show.table" #actionListTable id="actionListTable" [columns]="[
          {field: 'id_seq', title: '#', filterType: noFilter, sortable: false},
          {field: 'auditActionType', title: 'audit.actionType',
               bodyTemplate: ruleTypeTemplateRow, filterTemplate: noFilter,filterType: noFilter },
          {field: 'description', title: 'audit.ruleDtlDesc', filterTemplate: noFilter, filterType: noFilter }
          ]" [service]="rulesDtlService" [paginationType]="paginationType" [showRecoverButton]="false"
      [showInfoButton]="false" [showAddButton]="false" [showDeleteButton]="false" [showDetailsButton]="false"
      [showEditButton]="false" [additionalRowCommands]="actions" [filterBySingleColumn]="true" [expandTable]="false"
      [fetchActionListAsap]="false" [additionalRowCommands]="actions" [showGlobalFilter]="false"
      [showResetFiltersBtn]="false" [showRowButtons]="true">
      <ng-template #ruleTypeTemplateRow let-row>
        <span>{{getActionDescription(row)}}</span>
      </ng-template>
      <ng-template #actionList data-testid="actionList" let-row>
        <span style="text-transform: uppercase;">{{ getDescription(row) }}</span>
      </ng-template>

      <ng-template #noFilter data-testid="noFilter" let-col>

      </ng-template>

      <ng-template #actions let-row>
        <div class="detail-btn-container">
          <button class="btn-details" *ngIf="row.flg_state === '0' && row.flg_dpl === '0'"
            (click)="openEditAction(row.id)">
            <i class="pi pi-pencil icon-size"></i>
          </button>
          <button class="btn-details" *ngIf="!isChallenge && !isCustMovementRow(row) && row.flg_state === '0' "
            (click)="onRemoveRuleDtl(row.id)">
            <i class="pi pi-trash icon-size"></i>
          </button>
        </div>
      </ng-template>
    </app-campaign-3-kontable>
    <div class="ui-g-12 text-center">
      <button pButton type="button" *ngIf="!isChallenge" class="layoutDefaultFirstBtn" icon="fa fa-edit" iconPos="left"
        label="{{ 'audit.addNewAction' | translate }}" (click)="openAddNewAction()"></button>
      <br />
      <br />
    </div>
  </div>
</div>

<p-dialog class="new-action-dialog" *ngIf="showAddNewAction" [(visible)]="showAddNewAction" [modal]="true"
  [positionTop]="50" [minWidth]="700" [width]="800" [height]="800" [draggable]="false" [responsive]="true"
  [resizable]="false" (onHide)="closeAddNewAction()">
  <app-audit-new-action [isPopUp]="true" [clusterOption]="clusterOption"   [clusterOptionActive]="clusterOptionActive"
                        [acmList]="acmList" [acmListFull]="acmListFull"
    (closePopUp)="closeAddNewAction($event)" [auditRuleObject]="auditRuleObject" [ui_mode]="ui_mode"
    [listReasonsFiltered]="listReasonsFiltered" [listReasonsFull]="listReasonsFull"
    [auditRuleDtEditlId]="auditRuleDtEditlId" [actionsTypeCombo]="actionsTypeCombo" [actionsType]="actionsType"
    [readOnly]="isChallenge" (conditionObjectChanged)="onConditionObjectChanged($event)" [ruleId]="ruleId">
  </app-audit-new-action>
</p-dialog>



// WEBPACK FOOTER //
// ./src/app/views/audit/rules/add-rule/audit-action/audit-action.component.html